import { forEach } from 'lodash'
import { ConsumedData } from '../apis/consumed.api'
import { CaseData } from '../apis/inventoryCase.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  tableHorizontalData (
    consumeds: ConsumedData<CaseData>[]
  ): TableHorizontalData<ConsumedData<CaseData>>[] {
    forEach(consumeds,
      (consumed: TableHorizontalData<ConsumedData<CaseData>>) => {
        const actions: ActionName[] = ['rollback', 'print']
        consumed.actions = actions
        consumed.consumedQuantity = consumed.quantity || (consumed.consumable ? consumed.consumable.quantity : null)
        consumed.partialBadge = consumed.isPartial ? 'Partial QPC' : ''
      })
    return consumeds
  }
}
